import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { bindActionCreators } from "redux";
import { TextField, SelectField } from "redux-form-material-ui";
import { Card, CardText, CardTitle } from "material-ui/Card";
import { connect } from "react-redux";
import download from "downloadjs";
import moment from "moment";
import _ from "lodash";
import { Link } from "react-router-dom";
import { MenuItem, RaisedButton, FlatButton } from "material-ui";
import {
	actionDownloadFile,
	actionRegenerateTicket,
	actionUpdateBoleta
} from "../../actions/BoletaActions";
import { BOLETAS } from "../../config/RoutesConstants";
import Util, { SUCCESS, ERROR } from "../../common/Util";
import UtilPC from "../../common/UtilPC";
import VerticalListFields from "../../components/VerticalListFields/VerticalListFields";
import { MODE_CRU_SHOW, MODE_CRU_UPDATE } from "../../actions/ActionConstants";
import {
	ROL_ADMIN,
	ESTADO_TICKET_VENCIDO,
	ESTADO_TICKET_PAGADO,
	ESTADO_TICKET_ANULADO,
	ESTADO_TICKET_PENDIENTE_PAGO,
	ROL_EMPRESA,
	ROL_OPERADOR_AFFI,
	ROL_SUB_ADMIN,
	ROL_OPERADOR_RECAUDA
} from "../../common/Constants";
import AddPayment from "../../components/AddPayment/AddPayment";
import AppMem from "../../common/AppMem";
import { actionGetPaymentMethodList } from "../../actions/PaymentMethodActions";

class BoletaForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isTicketGenerated: false,
			status: this.props.boleta.ticketHeader.status
				? this.props.boleta.ticketHeader.status
				: null,
			total: 0
		};
		this.onTapConfirmPaid = this.onTapConfirmPaid.bind(this);
		this.calculoPagoParcial = this.calculoPagoParcial.bind(this);
	}

	componentWillMount() {
		if (!this.props.modeCRU) this.props.history.push(BOLETAS);
		else if (this.props.boleta) {
			this.props.actionGetPaymentMethodList();
			this.setState({
				status: this.props.boleta.ticketHeader.status
			});
			this.props.initialize({
				...this.props.boleta,
				monthPeriod: parseInt(this.props.boleta.monthPeriod, 10),
				yearPeriod: parseInt(this.props.boleta.yearPeriod, 10)
			});
			this.calculoPagoParcial();
		} else this.props.history.push(BOLETAS);
	}
	onPressGenerateBoleta() {
		this.props.actionGenerarBoletaPago(this.returnOnConfirm);
	}

	onConfirm() {
		this.props.actionRegenerateTicket(
			this.props.boleta.idPayment,
			this.props.boleta.ticketHeader.id,
			this.returnOnConfirm
		);
	}

	returnOnConfirm = response => {
		this.downloadFile(response.nombreArchivo);
	};

	downloadFile(fileName) {
		this.props.actionDownloadFile(fileName, this.returnDownload.bind(this));
	}

	returnDownload(blob) {
		let nombreArchivo =
			this.props.boleta.yearPeriod +
			"-" +
			this.props.boleta.monthPeriod +
			"-" +
			this.props.boleta.ticketHeader.id +
			"-UPSRA";
		download(blob, nombreArchivo);
		this.setState({ isTicketGenerated: true });
	}
	onSubmit(values) {
		let dateNow = new Date();
		dateNow = Util.formatDateToISODate(dateNow);
		let Date01 = false;
		let Date02 = false;
		if (dateNow <= values.ticketHeader.expiredDate01) Date01 = true;
		if (dateNow <= values.ticketHeader.expiredDate02) Date02 = true;
		let paidTotal = 0;
		let paidTotalFlag = false;
		if (values.ticketHeader.listPartialPayment === [])
			this.onTapConfirmPaid(values.ticketHeader);
		values.ticketHeader.listPartialPayment.forEach((partialPayment, i) => {
			paidTotal = parseFloat(paidTotal) + parseFloat(partialPayment.paidAmount);
			if (partialPayment.totalPayment) paidTotalFlag = true;
		});
		if (
			Date01 &&
			!paidTotalFlag &&
			paidTotal >= values.ticketHeader.feeAmount01
		) {
			AppMem.confirmDialog.open({
				title: "Registrar Los Pagos",
				messageConfirm:
					"¿Esta seguro que desea registrar los pagos aunque los pagos totales igualan o superan el 1º Vencimiento, sin registrarlo como pago total?",
				onAccept: this.onTapConfirmPaid.bind(values.ticketHeader)
			});
		} else if (
			Date02 &&
			!paidTotalFlag &&
			paidTotal >= values.ticketHeader.feeAmount02
		) {
			AppMem.confirmDialog.open({
				title: "Registrar Los Pagos",
				messageConfirm:
					"¿Esta seguro que desea registrar los pagos aunque los pagos totales igualan o superan el 2º Vencimiento, sin registrarlo como pago total?",
				onAccept: this.onTapConfirmPaid(values.ticketHeader)
			});
		} else {
			this.onTapConfirmPaid(values.ticketHeader);
		}
	}

	onTapConfirmPaid(valuesFinal) {
		this.props.actionUpdateBoleta(valuesFinal, this.onReturnUpdate.bind(this));
	}

	onReturnUpdate(flag) {
		if (flag) {
			Util.showNoty(SUCCESS, "Se registraron los pagos correctamente");
			this.props.history.push(BOLETAS);
		} else {
			Util.showNoty(ERROR, "Error al registrar los pagos");
		}
	}

	calculoPagoParcial() {
		let total = 0;
		let listPartialPayment = this.props.boleta.ticketHeader.listPartialPayment;
		if (listPartialPayment.length !== 0) {
			_.map(listPartialPayment, partialPayment => {
				total = total + partialPayment.paidAmount;
			});
		}
		this.setState({ total: Math.round(total * 100) / 100 });
	}

	render() {
		const { handleSubmit } = this.props;
		const modeShow = this.props.modeCRU;
		let meses = UtilPC.menuItemsMonths();
		return (
			<div className="center">
				<Card className="card">
					<CardTitle
						title={
							this.props.modeCRU === MODE_CRU_UPDATE
								? "Ver boleta de pago"
								: "Nueva boleta de pago"
						}
						subtitle={
							this.props.modeCRU === MODE_CRU_UPDATE
								? "Generar boleta de pago con recalculo de vencimientos o añadir pagos"
								: "Generar boleta de pago con recalculo de vencimientos"
						}
					/>
					<CardText>
						<form>
							<div className="content-papercard">
								<div className="columns-row-between" style={{ width: "75%" }}>
									<Field
										name="monthPeriod"
										component={SelectField}
										floatingLabelText="Mes"
										disabled
									>
										{meses}
									</Field>
									<Field
										name="yearPeriod"
										component={TextField}
										floatingLabelText="Año"
										disabled
									/>
									<Field
										name="ticketHeader.status"
										component={SelectField}
										floatingLabelText="Estado"
										disabled
									>
										<MenuItem
											value={ESTADO_TICKET_PENDIENTE_PAGO}
											key={1}
											primaryText={ESTADO_TICKET_PENDIENTE_PAGO}
										/>
										<MenuItem
											value={ESTADO_TICKET_PAGADO}
											key={2}
											primaryText={ESTADO_TICKET_PAGADO}
										/>
										<MenuItem
											value={ESTADO_TICKET_VENCIDO}
											key={3}
											primaryText={ESTADO_TICKET_VENCIDO}
										/>
										<MenuItem
											value={ESTADO_TICKET_ANULADO}
											key={4}
											primaryText={ESTADO_TICKET_ANULADO}
										/>
									</Field>
								</div>
								<VerticalListFields
									titleText="Vencimientos"
									titleClass="title-papercard-primary"
									paperClass="papercard top20 bottom20"
									contentClass="content-papercard-row-center padding20"
								>
									<div className="rows-column-simple bottom25">
										<div className="columns-row-between">
											<Field
												name="ticketHeader.feeAmount01"
												component={TextField}
												floatingLabelText="Total a Pagar"
												disabled
												format={Util.formatPesos}
											/>
											<Field
												name="ticketHeader.expiredDate01"
												component={TextField}
												floatingLabelText="1er Vencimiento"
												disabled
												format={Util.formatDateToShowNotHour}
												className="left20"
											/>
										</div>
										<Field
											name="ticketHeader.interes"
											component={TextField}
											floatingLabelText="Interes"
											disabled
											format={Util.formatPesos}
										/>
										<div className="columns-row-between ">
											<Field
												name="ticketHeader.feeAmount02"
												component={TextField}
												floatingLabelText="Total a Pagar"
												disabled
												format={Util.formatPesos}
											/>
											<Field
												name="ticketHeader.expiredDate02"
												component={TextField}
												floatingLabelText="2do Vencimiento"
												disabled
												format={Util.formatDateToShowNotHour}
												className="left20"
											/>
										</div>
									</div>
									<div className="columns-column-between columns-half bottom25 left20">
										{this.state.status === "ANULADO" ||
										(this.props.rol === ROL_EMPRESA ||
											this.props.rol === ROL_OPERADOR_AFFI) ? null : (
											<AddPayment
												nameFieldArray="ticketHeader.listPartialPayment"
												nameFieldPaymentDate="paidDate"
												nameFieldPayment="paidAmount"
												nameFieldCompletesPayment="totalPayment"
												addDisabled={
													this.state.status === "PAGADO" ? true : false
												}
												disabled={
													this.props.rol !== ROL_ADMIN &&
													this.props.rol !== ROL_SUB_ADMIN
														? true
														: false
												}
												paymentMethodsList={this.props.paymentMethodsList}
												nameFieldPaymentMethod={"paymentEntity.id"}
											/>
										)}
										<TextField
											name="partialPayment"
											value={Util.formatPesos(this.state.total)}
											floatingLabelText="Total de Pagos Parciales"
											disabled
										/>
									</div>
								</VerticalListFields>
							</div>
						</form>
						<div className="justify-content-end columns-column-simple">
							<Link to={BOLETAS}>
								<FlatButton label="Volver" style={{ margin: 5 }} />
							</Link>
							{modeShow !== MODE_CRU_SHOW ? (
								<div>
									{this.props.rol !== ROL_OPERADOR_AFFI &&
									this.props.rol !== ROL_OPERADOR_RECAUDA &&
									moment(this.props.boleta.ticketHeader.expiredDate02).isBefore(
										moment()
									) &&
									this.props.boleta.ticketHeader.status !==
										ESTADO_TICKET_PAGADO &&
									this.props.boleta.ticketHeader.status !==
										ESTADO_TICKET_ANULADO &&
									this.props.boleta.ticketHeader.status !==
										ESTADO_TICKET_VENCIDO ? (
										<RaisedButton
											label="Generar nueva boleta"
											primary
											style={{ margin: 5 }}
											onClick={this.onConfirm.bind(this)}
											disabled={this.state.isTicketGenerated}
										/>
									) : null}
									{this.props.rol === ROL_ADMIN ||
									this.props.rol === ROL_SUB_ADMIN ? (
										<RaisedButton
											label="Registrar Pagos"
											primary
											style={{ margin: 5 }}
											onClick={handleSubmit(this.onSubmit.bind(this))}
										/>
									) : null}
								</div>
							) : null}
						</div>
					</CardText>
				</Card>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		boleta: store.boleta.boleta,
		modeCRU: store.boleta.modeCRU,
		rol: store.app.rol,
		paymentMethodsList: store.paymentMethod.paymentMethodsList
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionDownloadFile,
			actionRegenerateTicket,
			actionUpdateBoleta,
			actionGetPaymentMethodList
		},
		dispatch
	);
}

export default reduxForm({
	form: "BoletaForm"
})(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(BoletaForm)
);



// WEBPACK FOOTER //
// ./src/screens/Boleta/BoletaForm.js